module.exports = __webpack_public_path__ + "img/mst2_card_image.56c9eab6.jpg";